import { LinkTo } from '@ember/routing';
import { t } from 'ember-intl';
import Svg from 'tio-employee/components/svg';
import { HStack, Section, VStack } from 'tio-ui/components/layout';
import Heading from 'tio-ui/components/heading';
import Text from 'tio-ui/components/text';

<template>
  <VStack>
    {{! How Can We Help You? }}
    <Section>
      <:body>
        <HStack>
          <VStack>
            <Heading @level={{1}}>
              {{t "coaching.about.how_can_we_help_q"}}
            </Heading>
            <Text @tag="p">
              {{t "coaching.about.how_can_we_help_a"}}
            </Text>

            {{! Anchor links }}
            <VStack>
              <a href="#ask-our-coaches" class="tio-anchor text-lg">
                {{t "coaching.about.ask_our_coaches"}}
              </a>
              <a href="#get-support" class="tio-anchor text-lg">
                {{t "coaching.about.get_support"}}
              </a>
              <a href="#previous-questions" class="tio-anchor text-lg">
                {{t "coaching.about.previous_questions"}}
              </a>
              <a href="#learn-about-coaches" class="tio-anchor text-lg">
                {{t "coaching.about.learn_about_coaches"}}
              </a>
            </VStack>
          </VStack>
          <div class="hidden sm:flex sm:w-1/3 justify-end">
            <Svg
              @name="woman-on-laptop-working"
              width="100%"
              height="100%"
              role="img"
              aria-label={{t "svg.woman_on_laptop_working"}}
            />
          </div>
        </HStack>
      </:body>
    </Section>

    {{! Ask our student loan coaches }}
    <Section>
      <:header>
        <span id="ask-our-coaches">{{t "coaching.about.ask_our_coaches"}}</span>
      </:header>
      <:body>
        <HStack>
          <VStack>
            <Text @tag="p">
              {{t "coaching.about.coaches_info_1"}}
            </Text>
            <Text @tag="p">
              {{t "coaching.about.coaches_info_2"}}
            </Text>
          </VStack>
          <div class="tio-row-flush sm:w-1/3 sm:pl-7 sm:border-l-4">
            <LinkTo
              @route="authenticated.repaying-student-debt.coaching.schedule"
              class="tio-anchor text-lg"
            >
              {{t "coaching.about.ask_coaches_link_text"}}
            </LinkTo>
          </div>
        </HStack>
      </:body>
    </Section>
    {{! Get program support }}
    <Section>
      <:header>
        <span id="get-support">{{t "coaching.about.get_support"}}</span>
      </:header>
      <:body>
        <HStack>
          <VStack>
            <Text @tag="p">
              {{t "coaching.about.support_info_pt1"}}
              {{t
                "coaching.about.support_info_pt2"
                class="tio-fg-info hover:tio-fg-info-h underline font-semibold"
                htmlSafe=true
              }}
              {{t "coaching.about.support_info_pt3"}}
            </Text>
          </VStack>
          <div class="tio-row-flush sm:w-1/3 sm:pl-7 sm:border-l-4">
            <LinkTo @route="authenticated.contact-us" class="tio-anchor text-lg">
              {{t "coaching.about.chat_link_text"}}
            </LinkTo>
          </div>
        </HStack>
      </:body>
    </Section>

    {{! See previously asked questions }}
    <Section>
      <:header>
        <span id="previous-questions">{{t "coaching.about.previous_questions"}}</span>
      </:header>
      <:body>
        <HStack>
          <VStack>
            <Text @tag="p">
              {{t "coaching.about.questions_info"}}
            </Text>
          </VStack>
          <div class="tio-row-flush sm:w-1/3 sm:pl-7 sm:border-l-4">
            <a href="https://www.tuition.io/blog/" class="tio-anchor text-lg">
              {{t "coaching.about.coach_blog_link_text"}}
            </a>
          </div>
        </HStack>
      </:body>
    </Section>

    {{! Learn about our coaches }}
    <Section>
      <:header>
        <span id="learn-about-coaches">{{t "coaching.about.learn_about_coaches"}}</span>
      </:header>
      <:body>
        <VStack @collapsed={{true}}>
          <Text @tag="p">
            {{t "coaching.about.learn_coaches_info_1"}}
          </Text>
          <Text @tag="p">
            {{t "coaching.about.learn_coaches_info_2"}}
          </Text>
          <Text @tag="p">
            {{t "coaching.about.learn_coaches_info_3"}}
          </Text>
        </VStack>
      </:body>
    </Section>
  </VStack>
</template>
